var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BannerModelBclass"},[_c('a-carousel',{staticClass:"Slideshow_box_Box",attrs:{"autoplay":_vm.autoplay,"dots":_vm.dots}},_vm._l((_vm.imgList),function(item,index){return _c('img',{key:index,staticClass:"Slideshow_box_carousel_img",attrs:{"src":item.content,"alt":""}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }